import { PublicModulesRouteMap } from '@/new-router/public-modules'

const overview = () => import('@/views/Storage/overview')
const whiteList = () => import('@/views/Storage/whiteList')
const management = () => import('@/views/Storage/management')
const autoClean = () => import('@/views/Storage/autoClean')
const Home = () => import('@/views/Home/home')
/**
* hidden: true                   是否显示在侧栏上
* meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
    nocache: true                组件将不keep-alive
  }
**/

export default [
  {
    path: '/storage',
    name: 'storage',
    component: Home,
    meta: {
      title: '存储管理',
      icon: 'icon-storage',
      showSubiems: false,
      sort: 11,
      modules: 'storage',
      permission: 'storage:root',
    },
    children: [
      {
        path: 'storage/overview',
        name: 'overview',
        component: overview,
        meta: {
          title: '存储概览',
          active: ['overview'],
          permission: 'storage:overview',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.StorageManagement],
        },
      }, {
        path: 'storage/whiteList',
        name: 'whiteList',
        component: whiteList,
        meta: {
          title: '清理管理',
          active: ['whiteList'],
          permission: 'clean:management',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.StorageManagement],
        },
      }, {
        path: 'storage/management',
        name: 'management',
        component: management,
        meta: {
          title: '存储管理',
          active: ['management'],
          permission: 'storage:manager',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.StorageManagement],
        },
      }, {
        path: 'storage/autoClean',
        name: 'autoClean',
        component: autoClean,
        meta: {
          title: '自动清理',
          active: ['autoClean'],
          permission: 'auto:clean',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.StorageManagement],
        },
      },
    ],
  },
]
